<template>
  <helpPage></helpPage>
</template>

<script>
import helpPage from "@/views/help/helpPage.vue";
export default {
  name: "ParamSetting",
  components: { helpPage },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>
